import axios from 'axios'
import history from '../../history'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

export async function getOpportunityByUser(dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.get('/job/getopportunitiesbyuser',
        {
            headers: {
                HEADERS,
                'Authorization': AuthToken
            }
        }).then(response => {
            successGetOpportunityByUser(response, dispatch);
        }).catch(erro => {
            erroGetOpportunityByUser(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successGetOpportunityByUser(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'SET_OPPORTUNITY',
            opportunities: response.data
        })
    }
}

function erroGetOpportunityByUser(erro, dispatch) {
    if (erro.status === 401) {
        history.push('/login')
    }
}
